export const copyNewsFiltersInitialState = {
  languageFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValue: 'all',
    componentName: 'languageFilter',
    translateKey: 'filter:language',
  },
  resourceTypeFilter: {
    hasFilter: false,
    isOpen: false,
    selectedIds: [],
    platform: 'news',
    componentName: 'resourceTypeFilter',
    translateKey: 'filter:resourceType',
  },
  resourceCategoryFilter: {
    hasFilter: false,
    isOpen: false,
    platform: 'news',
    componentName: 'resourceCategoryFilter',
    translateKey: 'filter:resourceCategory',
    selectedValue: '',
    filterType: 'include',
    hasIncludeExclude: true,
  },
  resourcesFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValue: 'include',
    selectedItems: {},
    hasIncludeExclude: true,
    platform: 'news',
    componentName: 'resourcesFilter',
    translateKey: 'filter:resourceSearch',
  },
  contentBasedFilter: {
    hasFilter: false,
    isOpen: false,
    selectedObjects: {
      influenceRate: {
        type: 'checkboxes',
        active: false,
        selectedIds: [],
        label: 'filter:resourceInfluenceRate',
      },
    },
    componentName: 'contentBasedFilter',
    translateKey: 'filter:contentBasedOn',
  },
};
